module.exports = __webpack_public_path__ + "static/img/news-icon3.d0f6a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news-icon3.png
// module id = ub/X
// module chunks = 1